






















































































































































































































































































































































































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import store from "@/store";
import events from "App/events";
//  @types
import { ExtendedVessel } from "@/types/vessel";
import { UserProfile } from "@/types/userProfile";
import { SnackbarConfig } from "@/types/snackbarConfig";
import { Company } from "@/types/company";
//  @components
import tooltip from "@/components/knockoutWrappers/TooltipWrapper.vue";
import Sidebar from "@/components/Sidebar.vue";
import ThemeSwitcher from "@/components/ThemeSwitcher.vue";
import vVesselTitle from "@/components/VesselTitle.vue";
import ShowAnnouncement from "@/components/Announcement/ShowAnnouncement.vue";
import AlertsMenu from "@/components/AlertsMenu/index.vue";
//  @clients
import VersionClient from "Clients/version-client";
//  @modules
import { getModule } from "vuex-module-decorators";
import AuthModule from "@/store/clients/Auth.module";
import UserModule from "@/store/clients/User.module";
import AnnouncementModule from "@/store/clients/Announcement.module";
import SnackbarModule from "@/store/clients/Snackbar.module";
import IncidentsModule from "@/store/clients/Incidents.module";
import VesselsModule from "@/store/clients/Vessels.module";
import UsersModule from "@/store/clients/Users.module";
import CompaniesModule from "@/store/clients/Companies.module";

const Auth = getModule(AuthModule, store);
const User = getModule(UserModule, store);
const Users = getModule(UsersModule, store);
const Snackbar = getModule(SnackbarModule, store);
const Announcement = getModule(AnnouncementModule, store);
const Incidents = getModule(IncidentsModule, store);
const Vessels = getModule(VesselsModule, store);
const Companies = getModule(CompaniesModule, store);

@Component({
  components: {
    tooltip,
    Sidebar,
    vVesselTitle,
    ShowAnnouncement,
    ThemeSwitcher,
    AlertsMenu,
  },
})
export default class App extends Vue {
  //  @Refs
  @Ref() AlertsMenu!: AlertsMenu;
  //  @Data
  searchVesselStr = "";
  selectedVessel: ExtendedVessel | null = null;
  selectedCompany: Company | null = null;
  showSidebar = true;
  showNewVersionNotification = false;
  lastUsedVersion = parseInt(Vue.$cookies.get("lastUsedVersion"));
  currentVersion!: number;
  errorEventBinding: any = null;
  isAlertsMenuOpen = false;
  refreshTimerId: number | null = null;

  ShowAnnouncementPopup = false;
  unreadAnnouncementCount = 0;
  unreadAnnouncementandNotification = 0;
  helpCategories = [
    {
      name: "What's new?",
      path: "VersionHistory",
    },
    {
      name: "Getting started",
      path: "GettingStarted",
    },
    {
      name: "FAQ",
      path: "FAQ",
      hasBottomBorder: true,
    },
    {
      name: "Basic Vessel Modules",
      path: "Basic",
    },
    {
      name: "Diagnostics",
      path: "Diagnostics",
    },
    {
      name: "Fouling",
      path: "Fouling",
    },
    {
      name: "Vessel Comparison",
      path: "Compare",
    },
    {
      name: "Charter Party",
      path: "CharterParty",
    },
    {
      name: "Alerts",
      path: "Notifications",
    },
    {
      name: "Emissions Compliance",
      path: "EmissionsCompliance",
    },
    {
      name: "CII",
      path: "CII",
    },
    {
      name: "ISO 19030",
      path: "ISO 19030",
    },
    {
      name: "Data Quality",
      path: "DataQuality",
      hasBottomBorder: true,
    },
  ];
  settings = [
    {
      name: "User List",
      path: "UserList",
      availability: ["Administrator", "SuperUser"],
    },
    // {
    //   name: "UserListOLD",
    //   path: "UserListOLD",
    //   availability: ["Administrator", "SuperUser"],
    // },
    {
      name: "Company List",
      path: "CompanyList",
      availability: ["Administrator"],
    },
    {
      name: "Vessel Access Control",
      path: "VesselAccessControl",
      availability: ["Administrator", "SuperUser"],
    },
    {
      name: "Vessel Groups",
      path: "VesselGroups",
      availability: ["Administrator", "SuperUser", "User"],
    },
    {
      name: "Manage Vessels",
      path: "ManageVessels",
      availability: ["Administrator"],
    },
    // {
    //   name: "Manage Vessels OLD",
    //   path: "ManageVesselsOLD",
    //   availability: ["Administrator"],
    // },
    {
      name: "Reference Curves",
      path: "ReferenceCurves",
      availability: ["Administrator"],
    },
    {
      name: "Announcements",
      path: "Announcement",
      availability: ["Administrator"],
    },
    {
      name: "Taxonomy",
      path: "Taxonomy",
      availability: ["Administrator"],
    },
    {
      name: "Import Status",
      path: "ImportStatus",
      availability: ["Administrator"],
    },
  ];

  //  @Watchers
  @Watch("isLoggedIn", { immediate: true })
  onLoggedInChanged(val: boolean) {
    if (val) {
      if (this.AlertsMenu) {
        this.AlertsMenu.fetchData();
        this.startRefreshTimer();
      }
    } else {
      if (this.refreshTimerId) {
        clearInterval(this.refreshTimerId);
        this.refreshTimerId = null;
      }
    }
  }

  @Watch("userProfile", { immediate: true })
  async onUserChange(): Promise<void> {
    if (!this.isLoggedIn) return;
    //  fetch companies and set selected company
    if (this.isAdmin) {
      await Companies.refreshCompanies();
      this.selectedCompany = this.userCompanyId ? this.companies.find(company => company.id === this.userCompanyId) ?? null : null;
    }
    //  fetch vessels and set selected vessel
    await Vessels.refreshExtendedVessels();
    // A vesselId in the route (e.g. a deep link) takes precedence over the last selected vessel
    const selectedVesselId = this.$route.params.vesselId ?? localStorage.getItem("selectedVesselId");
    if (this.extendedVessels.length > 0) {
      this.selectedVessel = selectedVesselId ? this.extendedVessels.find(vessel => vessel.id === parseInt(selectedVesselId)) ?? this.extendedVessels[0] : this.extendedVessels[0];
      localStorage.setItem("selectedVesselId", this.selectedVessel.id.toString());
      await Vessels.updateCurrentVesselById(this.selectedVessel.id);
    } else if (selectedVesselId) {
      localStorage.removeItem("selectedVesselId");
    }
    this.configureHeapAnalytics();
    //  run other checks
    Promise.all([this.announcementlistByUser(), this.showIsNewVersion(), this.checkTokenValidity()]);
  }

  // Sync selected vessel with vesselId in the route params (handles browser navigation and direct URL changes)
  @Watch("$route", { immediate: true, deep: true })
  onRouteChanged() {
    const vesselId = this.$route.params.vesselId;
    if (vesselId) {
      const vessel = this.extendedVessels.find(v => v.id === parseInt(vesselId));
      if (vessel && (!this.currentVessel || vessel.id !== this.currentVessel.id)) {
        this.selectedVessel = vessel;
        Vessels.updateCurrentVesselById(vessel.id);
      }
    }
  }

  configureHeapAnalytics(): void {
    const w = window as any;
    if (this.isLoggedIn && w.heap) {
      w.heap.addUserProperties({
        company_id: User.userCompanyId,
        company_name: User.userCompanyName,
        is_admin: User.isAdmin,
      });
    }
  }

  @Watch("selectedCompany", { deep: true })
  onCompanyChanged(company: Company, oldCompany: Company | null): void {
    if (oldCompany === null || company === null) return;
    if (company.id !== oldCompany.id) {
      if (this.$route.name !== "FleetOverview") this.$router.push("/FleetOverview");
      Users.viewAsCompany(company.id).then(() => {
        window.location.reload();
      });
    }
  }

  @Watch("currentVessel", { deep: true })
  onCurrentVesselChanged(vessel: ExtendedVessel, oldVessel: ExtendedVessel | null): void {
    if (vessel) localStorage.setItem("selectedVesselId", vessel.id.toString());
    if (oldVessel === null || vessel === null) return;
    if (vessel.id !== oldVessel.id) {
      this.selectedVessel = vessel;
    }
  }

  //  @Getters
  get isLoggedIn(): boolean {
    return Auth.isLoggedIn;
  }

  get isVesselRoute(): boolean {
    if (!this.$route) return false;
    return Boolean(this.$route.path.includes("Vessel") && this.$route.params.vesselId && this.$route.params.vesselName);
  }

  get isAdmin(): boolean {
    return User.isAdmin;
  }

  get isKognifai(): boolean {
    return User.isKognifai;
  }

  get userName(): string {
    return User.userName;
  }

  get userEmail(): string {
    return User.userEmail;
  }

  get userCompanyName(): string | null {
    return User.userCompanyName;
  }

  get userCompanyId(): number | null {
    return User.userCompanyId;
  }

  get userRole(): string | null {
    return User.userRole;
  }

  get notification(): SnackbarConfig {
    return Snackbar.message;
  }

  get userProfile(): UserProfile | null {
    return User.userProfile;
  }

  get extendedVessels(): ExtendedVessel[] {
    return Vessels.extendedVessels;
  }

  get companies(): Company[] {
    return Companies.companies;
  }

  get currentVessel(): ExtendedVessel | null {
    return Vessels.currentVessel;
  }

  get isCompanySelectAvailable(): boolean {
    return this.companies.length > 1;
  }

  get isVesselSelectAvailable(): boolean {
    return this.extendedVessels.length > 1;
  }

  get roleFilteredSettings(): any[] {
    return this.settings.filter(category => category.availability.includes(this.userRole ?? ""));
  }

  //  @Methods
  async showIsNewVersion(): Promise<void> {
    this.currentVersion = await VersionClient.getVersion();
    if (!this.lastUsedVersion || this.currentVersion > this.lastUsedVersion) this.showNewVersionNotification = true;
  }

  async checkTokenValidity(): Promise<void> {
    const isTokenValid = await Auth.isTokenValid();
    if (!isTokenValid) this.logOut();
  }

  async onSelectedVesselBlur(): Promise<void> {
    if (this.selectedVessel) return;
    this.selectedVessel = localStorage.getItem("selectedVesselId") ? this.extendedVessels.find(vessel => vessel.id === parseInt(localStorage.getItem("selectedVesselId")!)) ?? null : null;
    if (this.selectedVessel) await Vessels.updateCurrentVesselById(this.selectedVessel.id);
  }

  async onSelectedVesselChange(): Promise<void> {
    if (!this.selectedVessel) return;
    // Save the selected vessel ID in localStorage
    localStorage.setItem("selectedVesselId", this.selectedVessel.id.toString());
    // Update the current vessel in the store
    await Vessels.updateCurrentVesselById(this.selectedVessel.id);
    // Check the parent route
    const parentRoute = this.$route.matched[this.$route.matched.length - 2];

    // If the parent route is "Vessel", update the route params
    if (parentRoute?.path === "/Vessel/:vesselId/:vesselName") {
      this.$router.replace({
        // path: "/Vessel/:vesselId/:vesselName",
        name: this.$route.name ?? undefined, // Keep the current route name
        params: {
          ...this.$route.params, // Preserve existing params
          vesselName: this.selectedVessel.name,
          vesselId: this.selectedVessel.id.toString(),
        },
        query: this.$route.query,
        hash: this.$route.hash,
      });
    }
  }

  onSelectedCompanyBlur(): void {
    if (this.selectedCompany) return;
    this.selectedCompany = this.companies.find(company => company.id === this.userCompanyId) ?? null;
  }

  async announcementlistByUser(): Promise<void> {
    if (!this.isLoggedIn) return;
    const response = await Announcement.announcementListByUser();
    const filterdata = response.filter((item: { isView: boolean }) => item.isView === false);
    this.unreadAnnouncementCount = filterdata.length;

    const openIncidents = await Incidents.getFleetLevelOpenIncidents();
    const unacknowledgedIncidents = openIncidents.filter(item => item.acknowledged != true);
    const unacknowledgedIncidentsCount = unacknowledgedIncidents.length;

    this.unreadAnnouncementandNotification = this.unreadAnnouncementCount + unacknowledgedIncidentsCount;
  }

  navigateToVersionHistory(): void {
    Vue.$cookies.set("lastUsedVersion", this.currentVersion, "1y");
    this.showNewVersionNotification = false;
    this.lastUsedVersion = this.currentVersion;
    this.$router.push("/Help/VersionHistory");
  }

  closeSnackbar(): void {
    this.$store.dispatch("Snackbar/close");
  }

  logOut(): void {
    this.showNewVersionNotification = false;
    Auth.signOut().then(() => {
      this.$router.push("/login");
      window.location.reload();
    });
  }

  setVesselPerformanceStatus(vessel: ExtendedVessel): string {
    if (vessel.performance?.performanceStatus === "Ok") return "$StatusOk";
    if (vessel.performance?.performanceStatus === "Observe") return "$StatusObserve";
    if (vessel.performance?.performanceStatus === "NotOk") return "$StatusNotOk";
    if (vessel.performance?.performanceStatus === "BenchMarking") return "$StatusBenchmarking";
    return "mdi-close-circle-outline";
  }

  startRefreshTimer(): void {
    this.refreshTimerId = window.setInterval(() => {
      this.AlertsMenu.fetchData();
    }, 60000);
  }

  //  @Hooks
  mounted(): void {
    this.$root.$on("announcementlistByUser", async () => {
      await this.announcementlistByUser();
    });
    this.errorEventBinding = events.errorEvent.add((error: any) => {
      this.$store.dispatch("Snackbar/showSnackbar", {
        text: error.responseJSON.message || "An error occurred",
      });
    });
  }

  async created(): Promise<void> {
    this.delayedRegisterKnockoutComponents();
  }

  beforeDestroy(): void {
    this.errorEventBinding.detach();
    if (this.refreshTimerId) {
      clearInterval(this.refreshTimerId);
      this.refreshTimerId = null;
    }
  }

  //We dynamically register the knockout-components after user has been loaded,
  //so that kognifai users get served the correct templates
  delayedRegisterKnockoutComponents(): void {
    const unwatchNameChanged = this.$watch("userName", newVal => {
      if (newVal) {
        import("@/registerDelayedKnockoutComponents");
        unwatchNameChanged();
      }
    });
  }
}
